import * as socketio from "@/plugins/socketio";
import Vue from "vue";
import user from "./user";

export default {
  state: {
    users: {
      simfoni: {},
      harmoni: {},
      kanala: {},
    },
    history: {},
    private: {},
    notification: {
      aksi: [],
      informasi: [],
    },
  },
  getters: {
    GET_USERS: (state) => {
      return state.users;
    },
    GET_HISTORY: (state) => {
      return state.history;
    },
    GET_PRIVATE: (state) => {
      return state.private;
    },
  },
  mutations: {
    SET_USERS(state, payload) {
      if (payload.socketApp == "simfoni") {
        state.users.simfoni = payload;
      } else if(payload.socketApp == "harmoni"){
        state.users.harmoni = payload;
      } else {
        state.users.kanala = payload;
      }
    },
    ADD_USER(state, user) {
      Vue.set(state.users, user.id, user);
    },
    SET_HISTORY(state, history) {
      state.history = history;
    },
    ADD_MESSAGE(state, message) {
      Vue.set(state.history, message.id, message);
    },
    ADD_PRIVATE(state, msg) {
      state.private = msg;
    },
  },
  actions: {
    RECEIVE_USERS({ commit }, payload) {
      commit("SET_USERS", payload);
    },
    RECEIVE_USER({ commit }, user) {
      commit("ADD_USER", user);
    },
    RECEIVE_HISTORY({ commit }, history) {
      commit("SET_HISTORY", history);
    },
    RECEIVE_MESSAGE({ commit }, message) {
      commit("ADD_MESSAGE", message);
    },
    RECEIVE_PRIVATE({ commit }, message) {
      commit("ADD_PRIVATE", message);
    },
    SEND_EVENT({}, event) {
      if (event.socketType == "sim") {
        socketio.sendEventSim(event);
      } else if (event.socketType == "hrm") {
        socketio.sendEventHrm(event);
      } else if (event.socketType == "knl") {
        socketio.sendEventKnl(event);
      }
    },
  },
};
